import { useMobile } from 'src/hooks/useMobile'

import type { DropdownContentVariations } from '..'
import { SimpleListingDesktop } from './SimpleListingDesktop'
import { SimpleListingMobile } from './SimpleListingMobile'

export function SimpleListing({
  department,
  categorie,
  titleId,
  menuStyles,
  subcategories = [],
  setInHovering,
  setMenuIsOpen,
}: DropdownContentVariations) {
  const { isMobile } = useMobile()

  return (
    <>
      {isMobile ? (
        <SimpleListingMobile
          department={department}
          categorie={categorie}
          subCategories={subcategories}
          setMenuIsOpen={setMenuIsOpen}
        />
      ) : (
        <SimpleListingDesktop
          department={department}
          titleId={titleId}
          menuStyles={menuStyles}
          subCategories={subcategories}
          setInHovering={setInHovering ?? (() => {})}
        />
      )}
    </>
  )
}
